import { render } from "./PdfLabelRenderer.vue?vue&type=template&id=1d0f7785&scoped=true"
import script from "./PdfLabelRenderer.vue?vue&type=script&lang=js"
export * from "./PdfLabelRenderer.vue?vue&type=script&lang=js"

import "./PdfLabelRenderer.vue?vue&type=style&index=0&id=1d0f7785&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0f7785"]])

export default __exports__